import React from 'react';
import { Hero } from '../components/Hero';
import { ShortReviews } from '../components/ShortReviews';
import { PainSection } from '../components/PainSection';
import { ProductSection } from '../components/ProductSection';
import { BonusesSection } from '../components/BonusesSection';
import { OfferSection } from '../components/OfferSection';
import { UpsellSection } from '../components/UpsellSection';
import { LongTestimonials } from '../components/LongTestimonials';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { CostSection } from '../components/CostSection';
import { ClosingSection } from '../components/ClosingSection';
import { Footer } from '../components/Footer';
import { PurchasePopups } from '../components/PurchasePopups';
export type SalesPageProps = {
  showReviews: boolean;
  showPurchasePopups: boolean;
  showCountdown: boolean;
  showExtrasOffer: boolean;
  guaranteeEnabled: boolean;
};
export function SalesPage({
  showReviews,
  showPurchasePopups,
  showCountdown,
  showExtrasOffer,
  guaranteeEnabled
}: SalesPageProps) {
  const offerProps = {
    showCountdown,
    showExtrasOffer,
    guaranteeEnabled
  };
  return <div className="min-h-screen w-full bg-ink font-sans text-white antialiased" data-id="element-302" data-mp="30uyk8rfi1yzl">
      <Hero guaranteeEnabled={guaranteeEnabled} data-id="element-303" data-mp="2vvlmvcr059ir" />
      <main data-id="element-304" data-mp="2vsr2tmbwhqpv">
        {showReviews && <ShortReviews data-id="element-305" data-mp="3ticak6oozwaq" />}
        <PainSection data-id="element-306" data-mp="3tiubvhq7p0pi" />
        <ProductSection data-id="element-307" data-mp="3ti2j0eo01h2x" />
        <BonusesSection data-id="element-308" data-mp="3tghw9b7xf2fm" />
        <OfferSection variant="launch" {...offerProps} data-id="element-309" data-mp="3ojraq8dcremt" />
        {showExtrasOffer && <UpsellSection data-id="element-310" data-mp="3ohom9srultk7" />}
        {showReviews && <LongTestimonials data-id="element-311" data-mp="3jjn214ioro75" />}
        {guaranteeEnabled && <GuaranteeSection data-id="element-312" data-mp="3jmhjqoabeuwv" />}
        <FAQSection data-id="element-313" data-mp="3fj32xvejyaid" />
        <CostSection data-id="element-314" data-mp="3fhrql771jufn" />
        <OfferSection variant="final" {...offerProps} data-id="element-315" data-mp="3fi9u8ow19axl" />
        <ClosingSection data-id="element-316" data-mp="285rbz0q8tv15" />
      </main>
      <Footer data-id="element-317" data-mp="286sz43kja7z8" />
      {showPurchasePopups && <PurchasePopups data-id="element-318" data-mp="243ny65g3qecp" />}
    </div>;
}